/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Status of a card issuing authorization.
 */
export const IssuingAuthorizationStatus = {
  Pending: "pending",
  Declined: "declined",
  Canceled: "canceled",
  Cleared: "cleared",
  Expired: "expired",
} as const;
/**
 * Status of a card issuing authorization.
 */
export type IssuingAuthorizationStatus = ClosedEnum<
  typeof IssuingAuthorizationStatus
>;

/** @internal */
export const IssuingAuthorizationStatus$inboundSchema: z.ZodNativeEnum<
  typeof IssuingAuthorizationStatus
> = z.nativeEnum(IssuingAuthorizationStatus);
/** @internal */
export const IssuingAuthorizationStatus$outboundSchema: z.ZodNativeEnum<
  typeof IssuingAuthorizationStatus
> = IssuingAuthorizationStatus$inboundSchema;
